// assets/dcg-quick-view.js
(() => {
  const MODAL_ID = 'dcg-qv-modal';

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function setContent(html) {
    const modal = getModal();
    const content = qs(modal, '[data-dcg-qv-content]');
    if (content) content.innerHTML = html;
  }

  // ── Focus management ────────────────────────────────────────────
  // Store the element that opened the modal so we can restore focus on close
  let _qvTrigger = null;

  function openModal() {
    const modal = getModal();
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dcg-qv-lock');
    // Focus first focusable element inside panel after content loads
    setTimeout(() => {
      const panel = qs(modal, '.dcg-qv-modal__panel');
      const focusable = panel && panel.querySelector(
        'button:not([disabled]),a[href],input:not([disabled]),select,[tabindex]:not([tabindex="-1"])'
      );
      if (focusable) focusable.focus();
    }, 80);
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dcg-qv-lock');
    setContent('<div class="dcg-qv-modal__loading">Loading…</div>');
    // Restore focus to the element that opened the modal
    if (_qvTrigger) { _qvTrigger.focus({ preventScroll: true }); _qvTrigger = null; }
  }

  async function fetchWithTimeout(url, ms = 15000) {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), ms);
    try {
      return await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: ctrl.signal
      });
    } finally {
      clearTimeout(t);
    }
  }

  async function loadQuickView(url) {
    setContent('<div class="dcg-qv-modal__loading">Loading…</div>');

    const qvUrl = url.includes('view=quick-view') ? url : `${url}${url.includes('?') ? '&' : '?'}view=quick-view`;
    const res = await fetchWithTimeout(qvUrl, 15000);
    if (!res.ok) throw new Error(`HTTP ${res.status} loading quick view`);

    const html = await res.text();

    // If a full document comes back, extract <body>
    if (html.includes('<html') && html.includes('<body')) {
      const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
      if (bodyMatch && bodyMatch[1]) {
        setContent(bodyMatch[1]);
        return;
      }
    }

    setContent(html);
  }

  // Open / close + load
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-dcg-qv-open]');
    if (btn) {
      e.preventDefault();
      _qvTrigger = btn;  // remember for focus restoration
      const url = btn.getAttribute('data-dcg-qv-url') || btn.getAttribute('href');
      if (!url) return;

      openModal();
      try {
        await loadQuickView(url);
      } catch (err) {
        console.warn('[DCG QuickView] Error:', err);
        setContent(
          `<div style="padding:16px">
             <strong>Couldn’t load details.</strong><br>
             <a href="${url}" style="text-decoration:underline">Open product page</a>
           </div>`
        );
      }
      return;
    }

    if (e.target.closest('[data-dcg-qv-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    const modal = getModal();
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;

    if (e.key === 'Escape') { closeModal(); return; }

    // Focus trap
    if (e.key === 'Tab') {
      const panel = qs(modal, '.dcg-qv-modal__panel');
      if (!panel) return;
      const focusable = Array.from(
        panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])')
      ).filter(el => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  });

  // IMPORTANT:
  // We do NOT intercept submit anymore.
  // The quick view markup should use the same Shopify product form + classes
  // as the rest of the site, so the THEME handles AJAX + cart dropdown refresh.
})();